import React from "react";
import { createPortal } from "react-dom";
import withPlans from "../../../../hocs/withPlans";
import PageHelper from "../../../../lib/PageHelper";
import Loader from "../Loader";

import "./PaymentFormLoadingProvider.scss";

const PaymentFormLoadingProvider = ({ paymentFormLoading, locale }) => {
  if (!paymentFormLoading) {
    return null;
  }

  if (PageHelper.getIsOfferCheckoutPage(window.location, locale)) {
    return null;
  }

  return createPortal(
    <div className="payment-form-loading-overlay">
      <Loader />
    </div>,
    document.body
  );
};

export default withPlans(PaymentFormLoadingProvider);
